// ===== Constants =====

import {
    DEFAULT_USER_FIRST_NAME,
}                               from '../constants/generalConstants';

const LEGACY_ANONYMOUS_FIRST_NAMES = new Set([
    DEFAULT_USER_FIRST_NAME.toLowerCase(),
    'guest',
]);

const LEGACY_ANONYMOUS_LAST_NAMES = new Set([
    'reader',
]);

const normalizeNamePart = (value?: string): string => (
    value?.trim().toLowerCase() || ''
);

const hasExplicitPreferredName = ({
    preferredFirstName,
    preferredLastName,
}: {
    preferredFirstName?: string,
    preferredLastName?: string,
}): boolean => {
    const normalizedFirstName = normalizeNamePart(preferredFirstName);
    const normalizedLastName = normalizeNamePart(preferredLastName);

    if (normalizedFirstName.length > 0) {
        return !LEGACY_ANONYMOUS_FIRST_NAMES.has(normalizedFirstName);
    }
    if (normalizedLastName.length > 0) {
        return !LEGACY_ANONYMOUS_LAST_NAMES.has(normalizedLastName);
    }

    return false;
};

/**
 * Preserves trustworthy checkout/profile names, but still allows email
 * inference to replace obvious anonymous placeholder names.
 */
const resolvePreferredUserName = ({
    preferredFirstName,
    preferredLastName,
    fallbackFirstName,
    fallbackLastName,
}: {
    preferredFirstName?: string,
    preferredLastName?: string,
    fallbackFirstName?: string,
    fallbackLastName?: string,
}): {
    firstName?: string,
    lastName?: string,
} => {
    if (hasExplicitPreferredName({
        preferredFirstName,
        preferredLastName,
    })) {
        return {
            firstName: preferredFirstName || fallbackFirstName,
            lastName: preferredLastName || fallbackLastName,
        };
    }

    return {
        firstName: fallbackFirstName || preferredFirstName,
        lastName: fallbackLastName || preferredLastName,
    };
};

export default resolvePreferredUserName;
